module.exports = __webpack_public_path__ + "static/media/arrow-up-black.2a45077a.svg";